/**
 * Console-scoped components — see `./README.md` for the boundary
 * rules. Importable from `yaas-client` and `yaas-issuer` only.
 */

export { AccountOwnershipVerificationPanel } from "./AccountOwnershipVerificationPanel";
export type {
    AccountOwnershipVerificationPanelProps,
    VerificationCopy,
    VerificationMethod,
    VerificationStep
} from "./AccountOwnershipVerificationPanel";

export { AlertBadge, BoundaryBadge, CountChip, LifecycleStatusBadge, MetadataChip, OutcomeBadge } from "./badges";
export type {
    AlertBadgeProps,
    AlertSeverity,
    BoundaryBadgeProps,
    BoundaryTone,
    CountChipProps,
    CountTone,
    LifecycleStatusBadgeProps,
    LifecycleStatusTone,
    OutcomeBadgeProps,
    OutcomeTone,
    SemanticBadgeProps
} from "./badges";

export { ContentBlock } from "./ContentBlock";
export type { ContentBlockProps } from "./ContentBlock";

export { ResultPanel } from "./ResultPanel";
export type { ResultPanelProps } from "./ResultPanel";

export { SplitLayout } from "./SplitLayout";
export type { SplitColumn, SplitLayoutProps } from "./SplitLayout";
